import React, { useEffect } from 'react';
import { frontUrl } from '../config/Global';

const PaymentRedirect = ({ tokens, signature, admin, userData }) => {
    useEffect(() => {
        if (tokens && tokens.token) {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = 'https://ipg1.apps.net.pk/Ecommerce/api/Transaction/PostTransaction';

            const addHiddenField = (name, value) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                input.value = value;
                form.appendChild(input);
            };

            addHiddenField('MERCHANT_ID', admin?.merchant_id);
            addHiddenField('TOKEN', tokens.token);
            addHiddenField('CURRENCY_CODE', 'USD');
            addHiddenField('TXNAMT', tokens.paymentAmount);
            addHiddenField('BASKET_ID', tokens.basketId || '24998-SLCTZQ1TYSQ');
            addHiddenField('ORDER_DATE', new Date().toISOString().split('T')[0]);
            addHiddenField('SIGNATURE', signature);
            addHiddenField('VERSION', '1.0');
            addHiddenField('TXNDESC', `Subscription Payment - ${userData?.name || 'Plan'}`);
            addHiddenField('PROCCODE', '00');
            addHiddenField('TRAN_TYPE', 'ECOMM_PURCHASE');
            addHiddenField('CUSTOMER_MOBILE_NO', tokens?.phone || '03000000000');
            addHiddenField('CUSTOMER_EMAIL_ADDRESS', tokens?.email);
            addHiddenField('SUCCESS_URL', `${frontUrl}/Success?userData=${btoa(encodeURIComponent(JSON.stringify(userData)))}&admin=${btoa(encodeURIComponent(JSON.stringify(admin)))}`);
            addHiddenField('FAILURE_URL', `${frontUrl}/Failed?userData=${btoa(encodeURIComponent(JSON.stringify(userData)))}&admin=${btoa(encodeURIComponent(JSON.stringify(admin)))}`);
            addHiddenField('CHECKOUT_URL', `${frontUrl}/checkout`);
            addHiddenField('RECURRING_TXN', 'false');
            addHiddenField('ITEMS[0][SKU]', `SUB-${userData?.id || '001'}`);
            addHiddenField('ITEMS[0][NAME]', userData?.name || 'Subscription Plan');
            addHiddenField('ITEMS[0][PRICE]', tokens.paymentAmount);
            addHiddenField('ITEMS[0][QTY]', '1');

            document.body.appendChild(form);
            form.submit();
        }
    }, [tokens, signature, admin, userData]);

    return (
        <div className="fixed inset-0 bg-gray bg-opacity-30 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-xl">
                            <div className="flex flex-col items-center">
                                <div className="w-12 h-12 border-4 border-gray-500 border-t-transparent rounded-full animate-spin mb-4"></div>
                                <p className="text-gray-700 font-medium">Processing payment...</p>
                            </div>
                        </div>
                    </div>
    );
};

export default PaymentRedirect;
